import { ItemClass } from '../../item/types';
export function getRoot(fragment) {
    return fragment.root;
}
export function getRootId(fragment) {
    return getRoot(fragment).id;
}
export function isNotRoot(fragment, item) {
    return fragment.root.id !== item.id;
}
export function getItemById(fragment, id) {
    var item = fragment.items[id];
    if (item) {
        return item;
    }
    var root = fragment.root;
    if (root.className !== ItemClass.Canvas && root.id === id) {
        return root;
    }
    return null;
}
